var api = require("!../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../node_modules/css-loader/index.js??ref--8-1!../../node_modules/postcss-loader/lib/index.js!../../node_modules/sass-loader/dist/cjs.js??ref--8-3!../../node_modules/sass-resources-loader/lib/loader.js??ref--8-4!./Connected.scss");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {"insert":"body"};

options.insert = "body";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};